/* eslint-disable no-console, no-unused-vars, @typescript-eslint/no-unused-vars */
import axios from 'axios';

type AjaxHeaders = {
  'X-CSRF-Token':string
  'X-Requested-With':string
  Accept:string
}

type AjaxOpts = {
  headers?:AjaxHeaders
}

export type AjaxErrorMessage = {
  response: {
    data: {
      errors:string[]
    }
  }
}

type SuccessCallback = (response) => void
type ErrorCallback = (error:string | AjaxErrorMessage) => void

const getCSRFToken = () => {
  const csrfElement: HTMLElement | null = document.querySelector('meta[name=csrf-token]');

  return csrfElement instanceof HTMLMetaElement ? csrfElement.content : null;
};

export function ajaxGet(
  url:string,
  successCb:SuccessCallback = (_response) => { /* do nothing */ },
  errorCb:ErrorCallback = (error:string | AjaxErrorMessage) => { console.error(error); },
  { params = null, data = null } = {},
  opts:AjaxOpts = {},
) {
  const headers = opts.headers || {
    'X-CSRF-Token': getCSRFToken(),
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/javascript',
  };

  delete opts.headers;

  return axios({
    method: 'get', url, data, params, headers, ...opts,
  })
    .then((response) => {
      successCb(response);
    })
    .catch((error:string | AjaxErrorMessage) => {
      errorCb(error);
    });
}

export function ajaxPost(
  url:string,
  successCb:SuccessCallback = (_response) => { /* do nothing */ },
  errorCb:ErrorCallback = (error:string | AjaxErrorMessage) => { console.error(error); },
  data = null,
) {
  const headers = {
    'X-CSRF-Token': getCSRFToken(),
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/javascript',
  };

  return axios({
    method: 'post', url, data, headers,
  })
    .then((response) => {
      successCb(response);
    })
    .catch((error:string | AjaxErrorMessage) => {
      errorCb(error);
    });
}

export function ajaxPatch(
  url:string,
  successCb:SuccessCallback = (_response) => { /* do nothing */ },
  errorCb:ErrorCallback = (error:string | AjaxErrorMessage) => { console.error(error); },
  data = null,
  headerAuth = null,
) {
  const headers = {
    'X-CSRF-Token': getCSRFToken(),
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/javascript',
    Authorization: headerAuth ? `Bearer ${headerAuth}` : '',
  };

  return axios({
    method: 'patch', url, data, headers,
  })
    .then((response) => {
      successCb(response);
    })
    .catch((error:string | AjaxErrorMessage) => {
      errorCb(error);
    });
}

export function ajaxDelete(
  url:string,
  successCb:SuccessCallback = (_response) => { /* do nothing */ },
  errorCb:ErrorCallback = (error:string | AjaxErrorMessage) => { console.error(error); },
  headerAuth:string,
) {
  const headers = {
    'X-CSRF-Token': getCSRFToken(),
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/javascript',
    Authorization: headerAuth ? `Bearer ${headerAuth}` : '',
  };

  return axios({
    method: 'delete', url, headers,
  })
    .then((response) => {
      successCb(response);
    })
    .catch((error:string | AjaxErrorMessage) => {
      errorCb(error);
    });
}

export function getAjaxModal(
  modalPath:string,
  successCb = () => { /* do nothing */ },
  errorCb:ErrorCallback = (error:string | AjaxErrorMessage) => { console.error(error); },
  data = null,
  params = null,
) {
  const success = successCb || (() => { /* do nothing */ });
  const defaultErrorCb = (error:string | AjaxErrorMessage) => { console.error(error); };

  ajaxGet(
    modalPath,
    (response) => {
      eval(response.data); // eslint-disable-line no-eval

      success();
    },
    errorCb || defaultErrorCb,
    { params, data },
  );
}

export function insertAjaxContent({
  url,
  destElem,
  destPos = 'beforeend',
  successCb = (_response) => { /* do nothing */ },
  errorCb = (error:string | AjaxErrorMessage) => { console.error(error); },
  params = null,
  replaceContent = false,
}:
{
  url:string
  destElem:HTMLElement
  destPos?:InsertPosition
  successCb?:SuccessCallback
  errorCb?:ErrorCallback
  params
  replaceContent?:boolean
}) {
  const options = {
    headers: {
      'X-CSRF-Token': getCSRFToken(),
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'application/javascript',
    },
  };

  axios.get(url, { params, ...options })
    .then((response) => {
      if (replaceContent) {
        destElem.innerHTML = response.data;
      } else {
        destElem.insertAdjacentHTML(destPos, response.data);
      }
    })
    .then((response) => {
      successCb(response);
    })
    .catch((error:string | AjaxErrorMessage) => {
      errorCb(error);
    });
}
/* eslint-enable no-console, no-unused-vars, @typescript-eslint/no-unused-vars */
